/** Observation is best-effort and must never change the operation being observed. */
export type ErrorContext = Record<string, unknown>;
export type CaptureError = (error: unknown, context?: ErrorContext) => void;

export function errorCapture(send: (error: unknown, context: ErrorContext) => unknown, base: ErrorContext,
  options: { maxPending?: number; local?: CaptureError } = {}): CaptureError {
  const seen = new WeakSet<object>();
  let pending = 0;
  return (error, context = {}) => {
    try {
      if (error !== null && typeof error === 'object') {
        if (seen.has(error)) return;
        seen.add(error);
      }
      const properties = { ...base, ...context };
      try { options.local?.(error, properties); } catch { /* Independent of cloud availability. */ }
      if (pending >= (options.maxPending ?? Infinity)) return;
      pending++;
      let result: unknown;
      try { result = send(error, properties); } catch { pending--; return; }
      void Promise.resolve(result).catch(() => undefined).finally(() => { pending--; });
    } catch { /* Keep the local diagnostic path and the application working. */ }
  };
}
